module.exports = __webpack_public_path__ + "img/drawing.27cb5ee6.jpg";